import { SyncState } from '@/interfaces/states/sync-state.interface';

const state: SyncState = {
  isActive: false,
  progress: 0,
  errors: [],
};

export default state;
